import {
  Dashboard,
  Stock,
  Inflows,
  Outflows,
  Sales,
  Users,
  Products,
  Combinations,
  Clients,
  Providers,
  Payments,
  RegisterProduct,
  RegisterCombination,
  RegisterClient,
  RegisterProvider,
  RegisterPayment,
  RegisterSale,
  RegisterUser,
  Purchases,
  RegisterPurchase,
  DailyCashClosing,
  OrdersActives,
  Login,
  SaleDetail,
} from 'pages';
import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { RoutesEnum } from 'shared/constants';
import { EnumRoleUser } from 'shared/dtos';
import { useAuthContext, useDrawerContext } from 'shared/hooks';
import { ProtectedLayout } from 'shared/layouts';

import { DRAWER_OPTIONS_EMPLOYEE, DRAWER_OPTIONS_NORMAL, DRAWER_OPTIONS_SUPER } from './constants';

export function AppRoutes() {
  const { role } = useAuthContext();
  const { setDrawerOptions } = useDrawerContext();

  useEffect(() => {
    setDrawerOptions(
      role === EnumRoleUser.SUPER
        ? DRAWER_OPTIONS_SUPER
        : role === EnumRoleUser.NORMAL
        ? DRAWER_OPTIONS_NORMAL
        : DRAWER_OPTIONS_EMPLOYEE,
    );
  }, []);

  return (
    <Routes>
      <Route path={RoutesEnum.LOGIN} element={<Login />} />

      <Route
        path={RoutesEnum.STOCK}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Stock />
          </ProtectedLayout>
        }
      />

      <Route
        path={RoutesEnum.INFLOWS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Inflows />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.OUTFLOWS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Outflows />
          </ProtectedLayout>
        }
      />

      <Route
        path={RoutesEnum.DASHBOARD}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.NORMAL, EnumRoleUser.EMPLOYEE]}>
            <Dashboard />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PRODUCTS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Products />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.COMBINATIONS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Combinations />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.CLIENTS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Clients />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.SALES}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE, EnumRoleUser.NORMAL]}>
            <Sales />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PROVIDERS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Providers />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PURCHASES}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Purchases />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.USERS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.SUPER]}>
            <Users />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PAYMENTS}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <Payments />
          </ProtectedLayout>
        }
      />

      <Route
        path={RoutesEnum.PRODUCTS_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <RegisterProduct />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.COMBINATIONS_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <RegisterCombination />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.CLIENTS_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <RegisterClient />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.SALES_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE, EnumRoleUser.NORMAL]}>
            <RegisterSale />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PROVIDERS_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <RegisterProvider />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PURCHASES_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <RegisterPurchase />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.USERS_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.SUPER]}>
            <RegisterUser />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.PAYMENTS_CREATE}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <RegisterPayment />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.DAILY_CASH_CLOSING}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.EMPLOYEE]}>
            <DailyCashClosing />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.ORDERS_ACTIVES}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.NORMAL, EnumRoleUser.EMPLOYEE]}>
            <OrdersActives />
          </ProtectedLayout>
        }
      />
      <Route
        path={RoutesEnum.SALE_DETAIL}
        element={
          <ProtectedLayout accessUser={[EnumRoleUser.NORMAL, EnumRoleUser.EMPLOYEE]}>
            <SaleDetail />
          </ProtectedLayout>
        }
      />

      <Route path="*" element={<Navigate to={RoutesEnum.ORDERS_ACTIVES} />} />
    </Routes>
  );
}
